import * as React from 'react';
import { Switch, Route } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import { history, store } from 'src/store';
import Root from './Root';

import 'antd/lib/form/style';
import './App.less';
import { GLogin } from './auth';

class App extends React.Component {
  render() {
    return (
      <ConnectedRouter history={history}>
        <Switch>
          <Route path="/login" component={GLogin} />
          <Route path="/" component={Root} />
        </Switch>
      </ConnectedRouter>
    );
  }
}

export default class extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App.tsx